// import React, { useEffect, useState } from "react";
// import { Table, Pagination } from "react-bootstrap";
// const API_URL = process.env.REACT_APP_API_URL;
// function PropertyLeadPaymentList() {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 500;
//   const getAuthToken = () => localStorage.getItem("token");
//   const fetchPayments = async () => {
//     setLoading(true);
//     setError("");
//     setSuccessMessage("");
//     try {
//       const token = getAuthToken();

//       if (!token) {
//         throw new Error(
//           "Authentication token not found. Please login again."
//         );
//       }

//       const response = await fetch(
//         `${API_URL}/property-lead-payment-list`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.message || "Failed to fetch payments."
//         );
//       }

//       if (result.success === "1") {
//         const allPayments = result.data || [];

//         // ✅ Sirf reject payments dikhao (backend status = "reject")
//         const rejectedPayments = allPayments.filter(
//           (p) => p.payment_status === "rejected"
//         );

//         setPayments(rejectedPayments);
//         setCurrentPage(1);
//       } else {
//         setPayments([]);
//         setError(result.message || "No payment records found.");
//       }
//     } catch (err) {
//       console.error("Property Lead Payment List Error:", err);
//       setError(err.message || "Something went wrong.");
//       setPayments([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayments();
//   }, []);

//   const formatPaymentMethod = (method) =>
//     ({
//       cash: "Cash",
//       upi: "UPI",
//       qr: "QR",
//       bank_transfer: "Bank Transfer",
//     }[method] || method || "-");

//   // ✅ "reject" bhi handle kiya
//   const formatStatus = (status) =>
//     ({
//       pending: "Pending",
//       approve: "Approved",
//       approved: "Approved",
//       reject: "Rejected",
//       rejected: "Rejected",
//     }[status] || status || "-");

//   // ✅ "reject" bhi handle kiya
//   const statusClass = (status) =>
//     ({
//       pending: "bg-warning text-dark",
//       approve: "bg-success text-white",
//       approved: "bg-success text-white",
//       reject: "bg-danger text-white",
//       rejected: "bg-danger text-white",
//     }[status] || "bg-secondary text-white");

//   const formatDate = (date) => {
//     if (!date) return "-";

//     const d = new Date(date);

//     return Number.isNaN(d.getTime())
//       ? date
//       : d.toLocaleString("en-IN", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//           hour: "2-digit",
//           minute: "2-digit",
//         });
//   };

//   const totalPages = Math.max(
//     1,
//     Math.ceil(payments.length / rowsPerPage)
//   );

//   const startIndex = (currentPage - 1) * rowsPerPage;

//   const currentPayments = payments.slice(
//     startIndex,
//     startIndex + rowsPerPage
//   );

//   return (
//     <div className="userlist mt-2">
//       <div className="card">
//         <div className="card-header">
//           <div className="d-flex flex-wrap-mobile gap-2 align-items-center justify-content-between">
//             <div className="titlepage">
//               <h3>Rejected Property Lead Payments</h3>
//             </div>

//             <button
//               className="btn btn-primary"
//               onClick={fetchPayments}
//               disabled={loading}
//             >
//               {loading ? "Loading..." : "Refresh"}
//             </button>
//           </div>
//         </div>

//         <div className="card-body">
//           {successMessage && (
//             <div className="alert alert-success">
//               {successMessage}
//             </div>
//           )}

//           {error && (
//             <div className="alert alert-danger d-flex justify-content-between align-items-center">
//               <span>{error}</span>

//               <button
//                 className="btn btn-sm btn-danger"
//                 onClick={fetchPayments}
//               >
//                 Retry
//               </button>
//             </div>
//           )}

//           <div className="table-responsive">
//             <Table bordered hover className="align-middle">
//               <thead className="bg-primary text-white">
//                 <tr>
//                   <th>S.N</th>
//                   <th>Associate Name</th>
//                   <th>Associate Mobile</th>
//                   <th>Project Name</th>
//                   <th>Block Name</th>
//                   <th>Unit Number</th>
//                   <th>Amount</th>
//                   <th>Payment Method</th>
//                   <th>Transaction / UTR</th>
//                   <th>Payment Date</th>
//                   <th>Payment Status</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="11" className="text-center py-4">
//                       Loading payments...
//                     </td>
//                   </tr>
//                 ) : currentPayments.length > 0 ? (
//                   currentPayments.map((payment, index) => (
//                     <tr key={payment.id}>
//                       <td>{startIndex + index + 1}</td>

//                       <td>{payment.user_name || "-"}</td>

//                       <td>{payment.user_mobile || "-"}</td>

//                       <td>{payment.project_name || "-"}</td>

//                       <td>{payment.block_name || "-"}</td>

//                       <td>{payment.plot_shop_villa_no || "-"}</td>

//                       <td>
//                         <strong>
//                           ₹{" "}
//                           {Number(payment.amount || 0).toLocaleString(
//                             "en-IN",
//                             {
//                               minimumFractionDigits: 2,
//                               maximumFractionDigits: 2,
//                             }
//                           )}
//                         </strong>
//                       </td>

//                       <td>
//                         <span className="badge bg-info text-dark">
//                           {formatPaymentMethod(payment.payment_method)}
//                         </span>
//                       </td>

//                       <td>{payment.transaction_id || "-"}</td>

//                       <td>{formatDate(payment.created_at)}</td>

//                       <td>
//                         <span
//                           className={`badge ${statusClass(
//                             payment.payment_status
//                           )}`}
//                         >
//                           {formatStatus(payment.payment_status)}
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="11" className="text-center py-4">
//                       No payment records found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           {payments.length > 0 && (
//             <div className="d-flex justify-content-end mt-3">
//               <Pagination>
//                 <Pagination.Prev
//                   onClick={() =>
//                     setCurrentPage((p) => Math.max(1, p - 1))
//                   }
//                   disabled={currentPage === 1}
//                 />

//                 {Array.from(
//                   { length: totalPages },
//                   (_, i) => i + 1
//                 ).map((page) => (
//                   <Pagination.Item
//                     key={page}
//                     active={page === currentPage}
//                     onClick={() => setCurrentPage(page)}
//                   >
//                     {page}
//                   </Pagination.Item>
//                 ))}

//                 <Pagination.Next
//                   onClick={() =>
//                     setCurrentPage((p) =>
//                       Math.min(totalPages, p + 1)
//                     )
//                   }
//                   disabled={currentPage === totalPages}
//                 />
//               </Pagination>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default PropertyLeadPaymentList;

// import React, { useEffect, useState } from "react";
// import { Table, Pagination } from "react-bootstrap";

// const API_URL = process.env.REACT_APP_API_URL;

// function PropertyLeadPaymentList() {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   const rowsPerPage = 500;

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchPayments = async () => {
//     setLoading(true);
//     setError("");
//     setSuccessMessage("");

//     try {
//       const token = getAuthToken();

//       if (!token) {
//         throw new Error(
//           "Authentication token not found. Please login again."
//         );
//       }

//       const response = await fetch(
//         `${API_URL}/property-lead-payment-list`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.message || "Failed to fetch payments."
//         );
//       }

//       if (result.success === "1") {
//         const allPayments = result.data || [];

//         // ✅ Sirf reject payments dikhao (backend status = "reject")
//         const rejectedPayments = allPayments.filter(
//           (p) => p.payment_status === "rejected"
//         );

//         setPayments(rejectedPayments);
//         setCurrentPage(1);
//       } else {
//         setPayments([]);
//         setError(result.message || "No payment records found.");
//       }
//     } catch (err) {
//       console.error("Property Lead Payment List Error:", err);
//       setError(err.message || "Something went wrong.");
//       setPayments([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayments();
//   }, []);

//   const formatPaymentMethod = (method) =>
//     ({
//       cash: "Cash",
//       upi: "UPI",
//       qr: "QR",
//       bank_transfer: "Bank Transfer",
//     }[method] || method || "-");

//   // ✅ "reject" bhi handle kiya
//   const formatStatus = (status) =>
//     ({
//       pending: "Pending",
//       approve: "Approved",
//       approved: "Approved",
//       reject: "Rejected",
//       rejected: "Rejected",
//     }[status] || status || "-");

//   // ✅ "reject" bhi handle kiya
//   const statusClass = (status) =>
//     ({
//       pending: "bg-warning text-dark",
//       approve: "bg-success text-white",
//       approved: "bg-success text-white",
//       reject: "bg-danger text-white",
//       rejected: "bg-danger text-white",
//     }[status] || "bg-secondary text-white");

//   const formatDate = (date) => {
//     if (!date) return "-";

//     const d = new Date(date);

//     return Number.isNaN(d.getTime())
//       ? date
//       : d.toLocaleString("en-IN", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//           hour: "2-digit",
//           minute: "2-digit",
//         });
//   };

//   const totalPages = Math.max(
//     1,
//     Math.ceil(payments.length / rowsPerPage)
//   );

//   const startIndex = (currentPage - 1) * rowsPerPage;

//   const currentPayments = payments.slice(
//     startIndex,
//     startIndex + rowsPerPage
//   );

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1800px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               ❌
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Rejected Property Lead Payments
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 View all rejected property lead payments
//               </p>
//             </div>

//             <button
//               onClick={fetchPayments}
//               disabled={loading}
//               style={{
//                 padding: "12px 20px",
//                 borderRadius: "12px",
//                 border: "none",
//                 background: loading
//                   ? "#94a3b8"
//                   : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 color: "#ffffff",
//                 fontWeight: "700",
//                 fontSize: "14px",
//                 cursor: loading ? "not-allowed" : "pointer",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//               }}
//             >
//               {loading ? "Loading..." : "🔄 Refresh"}
//             </button>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               {/* Success Message */}
//               {successMessage && (
//                 <div
//                   style={{
//                     background: "#ecfdf5",
//                     border: "1.5px solid #a7f3d0",
//                     color: "#065f46",
//                     borderRadius: "12px",
//                     padding: "14px 18px",
//                     marginBottom: "20px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {successMessage}
//                 </div>
//               )}

//               {/* Error Message */}
//               {error && (
//                 <div
//                   style={{
//                     background: "#fef2f2",
//                     border: "1.5px solid #fecaca",
//                     color: "#991b1b",
//                     borderRadius: "12px",
//                     padding: "14px 18px",
//                     marginBottom: "20px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     gap: "12px",
//                   }}
//                 >
//                   <span>{error}</span>
//                   <button
//                     onClick={fetchPayments}
//                     style={{
//                       padding: "6px 14px",
//                       borderRadius: "8px",
//                       border: "none",
//                       background: "#dc2626",
//                       color: "#ffffff",
//                       fontWeight: "700",
//                       fontSize: "13px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Retry
//                   </button>
//                 </div>
//               )}

//               {loading ? (
//                 <div
//                   style={{
//                     textAlign: "center",
//                     padding: "60px 20px",
//                     color: "#64748b",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "40px",
//                       height: "40px",
//                       border: "3px solid #cbd5e1",
//                       borderTop: "3px solid #2b6cb0",
//                       borderRadius: "50%",
//                       display: "inline-block",
//                       animation: "spin 0.8s linear infinite",
//                     }}
//                   />
//                   <p
//                     style={{
//                       marginTop: "16px",
//                       fontSize: "14px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Loading Rejected Payments...
//                   </p>
//                 </div>
//               ) : (
//                 <>
//                   <div className="table-responsive">
//                     <Table bordered hover style={{ minWidth: "1300px" }}>
//                       <thead
//                         style={{
//                           background:
//                             "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                           color: "#ffffff",
//                         }}
//                       >
//                         <tr>
//                           <th>S.N</th>
//                           <th>Associate Name</th>
//                           <th>Associate Mobile</th>
//                           <th>Project Name</th>
//                           <th>Block Name</th>
//                           <th>Unit Number</th>
//                           <th>Amount</th>
//                           <th>Payment Method</th>
//                           <th>Transaction / UTR</th>
//                           <th>Payment Date</th>
//                           <th>Payment Status</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentPayments.length > 0 ? (
//                           currentPayments.map((payment, index) => (
//                             <tr key={payment.id}>
//                               <td>{startIndex + index + 1}</td>
//                               <td>{payment.user_name || "-"}</td>
//                               <td>{payment.user_mobile || "-"}</td>
//                               <td>{payment.project_name || "-"}</td>
//                               <td>{payment.block_name || "-"}</td>
//                               <td>{payment.plot_shop_villa_no || "-"}</td>
//                               <td>
//                                 <strong>
//                                   ₹{" "}
//                                   {Number(
//                                     payment.amount || 0
//                                   ).toLocaleString("en-IN", {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2,
//                                   })}
//                                 </strong>
//                               </td>
//                               <td>
//                                 <span className="badge bg-info text-dark">
//                                   {formatPaymentMethod(
//                                     payment.payment_method
//                                   )}
//                                 </span>
//                               </td>
//                               <td>{payment.transaction_id || "-"}</td>
//                               <td>{formatDate(payment.created_at)}</td>
//                               <td>
//                                 <span
//                                   className={`badge ${statusClass(
//                                     payment.payment_status
//                                   )}`}
//                                 >
//                                   {formatStatus(payment.payment_status)}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td
//                               colSpan="11"
//                               className="text-center py-4"
//                               style={{
//                                 color: "#dc2626",
//                                 fontWeight: "700",
//                               }}
//                             >
//                               No rejected payment records found.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {payments.length > 0 && (
//                     <div className="d-flex justify-content-end mt-3">
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() =>
//                             setCurrentPage((p) => Math.max(1, p - 1))
//                           }
//                           disabled={currentPage === 1}
//                         />

//                         {Array.from(
//                           { length: totalPages },
//                           (_, i) => i + 1
//                         ).map((page) => (
//                           <Pagination.Item
//                             key={page}
//                             active={page === currentPage}
//                             onClick={() => setCurrentPage(page)}
//                           >
//                             {page}
//                           </Pagination.Item>
//                         ))}

//                         <Pagination.Next
//                           onClick={() =>
//                             setCurrentPage((p) =>
//                               Math.min(totalPages, p + 1)
//                             )
//                           }
//                           disabled={currentPage === totalPages}
//                         />
//                       </Pagination>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// }

// export default PropertyLeadPaymentList;

import React, { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;
const ROWS_PER_PAGE = 500;

function RejectedPropertyLeadPaymentList() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH REJECTED PAYMENTS
  // ═══════════════════════════════════════════
  const fetchPayments = async () => {
    setLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const token = getAuthToken();
      if (!token) {
        throw new Error("Authentication token not found. Please login again.");
      }

      const response = await fetch(`${API_URL}/property-lead-payment-list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch payments.");
      }

      if (result.success === "1") {
        const allPayments = result.data || [];

        // ✅ Sirf rejected payments (reject + rejected dono handle)
        const rejectedPayments = allPayments.filter(
          (p) =>
            p.payment_status === "reject" ||
            p.payment_status === "rejected"
        );

        setPayments(rejectedPayments);
        setCurrentPage(1);
      } else {
        setPayments([]);
        setError(result.message || "No payment records found.");
      }
    } catch (err) {
      console.error("Property Lead Payment List Error:", err);
      setError(err.message || "Something went wrong.");
      setPayments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FORMATTERS
  // ═══════════════════════════════════════════
  const formatPaymentMethod = (method) =>
    ({
      cash: "Cash",
      upi: "UPI",
      qr: "QR",
      bank_transfer: "Bank Transfer",
    }[method] ||
      method ||
      "-");

  const formatStatus = (status) =>
    ({
      pending: "Pending",
      approve: "Approved",
      approved: "Approved",
      reject: "Rejected",
      rejected: "Rejected",
    }[status] ||
      status ||
      "-");

  const getStatusStyle = (status) => {
    switch (status) {
      case "pending":
        return { bg: "#fef3e2", color: "#d97706" };
      case "approve":
      case "approved":
        return { bg: "#e7f9eb", color: "#059669" };
      case "reject":
      case "rejected":
        return { bg: "#feeaeb", color: "#dc2626" };
      default:
        return { bg: "#f1f5f9", color: "#64748b" };
    }
  };

  const getPaymentMethodStyle = (method) => {
    switch (method) {
      case "cash":
        return { bg: "#e7f9eb", color: "#059669" };
      case "upi":
        return { bg: "#e8f1fb", color: "#1e5799" };
      case "qr":
        return { bg: "#f3e8ff", color: "#7c3aed" };
      case "bank_transfer":
        return { bg: "#fef3e2", color: "#d97706" };
      default:
        return { bg: "#f1f5f9", color: "#64748b" };
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return Number.isNaN(d.getTime())
      ? date
      : d.toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION
  // ═══════════════════════════════════════════
  const totalPages = Math.max(1, Math.ceil(payments.length / ROWS_PER_PAGE));
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const currentPayments = payments.slice(
    startIndex,
    startIndex + ROWS_PER_PAGE
  );

  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1800px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #dc2626, #b91c1c)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(220, 38, 38, 0.3)",
                  flexShrink: 0,
                }}
              >
                ❌
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Rejected Property Lead Payments
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  View all rejected property lead payments ({payments.length}{" "}
                  total)
                </p>
              </div>
            </div>

            <button
              onClick={fetchPayments}
              disabled={loading}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "none",
                background: loading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                cursor: loading ? "not-allowed" : "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: loading
                  ? "none"
                  : "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              🔄 Refresh
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Success Message */}
            {successMessage && (
              <div
                style={{
                  background: "#e7f9eb",
                  border: "1.5px solid #a7f3d0",
                  color: "#065f46",
                  borderRadius: "12px",
                  padding: "14px 18px",
                  marginBottom: "20px",
                  fontWeight: "600",
                  fontSize: "13.5px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                ✅ {successMessage}
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div
                style={{
                  background: "#feeaeb",
                  border: "1.5px solid #fecaca",
                  color: "#991b1b",
                  borderRadius: "12px",
                  padding: "14px 18px",
                  marginBottom: "20px",
                  fontWeight: "600",
                  fontSize: "13.5px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span>⚠️ {error}</span>
                <button
                  onClick={fetchPayments}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "8px",
                    border: "none",
                    background: "#dc2626",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  Retry
                </button>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1400px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Associate Name",
                      "Mobile",
                      "Project",
                      "Block",
                      "Unit No.",
                      "Amount",
                      "Method",
                      "Transaction / UTR",
                      "Payment Date",
                      "Status",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {currentPayments.length > 0 ? (
                    currentPayments.map((payment, index) => (
                      <tr
                        key={payment.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>{startIndex + index + 1}</td>
                        <td style={cellDark}>{payment.user_name || "-"}</td>
                        <td style={cellGray}>{payment.user_mobile || "-"}</td>
                        <td style={cellDark}>
                          {payment.project_name || "-"}
                        </td>
                        <td style={cellGray}>{payment.block_name || "-"}</td>
                        <td style={cellText}>
                          {payment.plot_shop_villa_no || "-"}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "700",
                            color: "#dc2626",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ₹{" "}
                          {Number(payment.amount || 0).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background: getPaymentMethodStyle(
                                payment.payment_method
                              ).bg,
                              color: getPaymentMethodStyle(
                                payment.payment_method
                              ).color,
                              textTransform: "capitalize",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {formatPaymentMethod(payment.payment_method)}
                          </span>
                        </td>
                        <td style={cellGray}>
                          {payment.transaction_id || "-"}
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {formatDate(payment.created_at)}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background: getStatusStyle(payment.payment_status)
                                .bg,
                              color: getStatusStyle(payment.payment_status)
                                .color,
                              textTransform: "capitalize",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {formatStatus(payment.payment_status)}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="11"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No rejected payment records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => setCurrentPage(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() =>
                    setCurrentPage((p) => Math.min(totalPages, p + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color:
                      currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {/* Page Info */}
            {payments.length > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {payments.length} total
                rejected records
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = { padding: "12px", fontWeight: "600", color: "#1e5799" };

export default RejectedPropertyLeadPaymentList;